import { el } from '../utils/dom.js';

/**
 * ShortcutOverlay — Press H to show/hide a floating keyboard shortcut reference.
 */
export class ShortcutOverlay {
  constructor() {
    this._visible = false;
    this._el = null;
  }

  toggle() {
    if (this._visible) this.hide();
    else this.show();
  }

  show() {
    if (this._el) return;
    this._visible = true;

    const overlay = el('div', { className: 'shortcut-overlay' });

    const title = el('h2', { style: { margin: '0 0 12px', fontSize: '16px', fontWeight: '600' } }, 'Keyboard Shortcuts');

    overlay.appendChild(title);
    overlay.appendChild(this._section('Tools', [
      ['B', 'Pencil'], ['R', 'Rectangle'], ['G', 'Fill'], ['E', 'Eraser'],
      ['S', 'Select'], ['L', 'Line'], ['T', 'Terrain'], ['D', 'Scatter'],
      ['P', 'Property Brush'], ['O', 'Object'],
    ]));
    overlay.appendChild(this._section('Drawing', [
      ['[ / ]', 'Brush size'], ['X', 'Flip horizontal'], ['Y', 'Flip vertical'],
      ['Z', 'Rotate CW'], ['Shift+Z', 'Rotate CCW'], ['Alt+Click', 'Eyedropper'],
      ['Shift+Click', 'Magic wand (Select tool)'],
    ]));
    overlay.appendChild(this._section('Stamps', [
      ['Ctrl+1-9', 'Save stamp to slot'], ['1-9', 'Recall stamp'],
      ['Arrow keys', 'Navigate palette'],
    ]));
    overlay.appendChild(this._section('View', [
      ['Scroll', 'Pan up/down'], ['Shift+Scroll', 'Pan left/right'],
      ['Ctrl+Scroll', 'Zoom'], ['Space+Drag', 'Hand tool (pan)'],
      ['Home', 'Reset view'], ['Ctrl+0', 'Reset view'],
      ['#', 'Toggle grid'], ['Ctrl+P', 'Command palette'],
    ]));
    overlay.appendChild(this._section('File', [
      ['Ctrl+N', 'New map'], ['Ctrl+O', 'Open'], ['Ctrl+S', 'Save'],
      ['Ctrl+Shift+S', 'Save as'], ['Ctrl+Z', 'Undo'], ['Ctrl+Y', 'Redo'],
    ]));
    overlay.appendChild(this._section('Layers', [
      ['Page Up/Down', 'Switch layer'],
    ]));
    overlay.appendChild(this._section('Selection', [
      ['Ctrl+C', 'Copy'], ['Ctrl+V', 'Paste'], ['Delete', 'Delete selection'],
      ['Escape', 'Cancel'],
    ]));

    const closeHint = el('div', {
      style: { textAlign: 'center', marginTop: '12px', fontSize: '11px', color: 'var(--text-dim)' },
    }, 'Press H or Escape to close');
    overlay.appendChild(closeHint);

    document.body.appendChild(overlay);
    this._el = overlay;

    // Close on Escape or H
    this._keyHandler = (e) => {
      if (e.key === 'Escape' || (e.key.toLowerCase() === 'h' && !e.ctrlKey && !e.metaKey)) {
        this.hide();
      }
    };
    document.addEventListener('keydown', this._keyHandler);
  }

  hide() {
    if (this._el) {
      this._el.remove();
      this._el = null;
    }
    this._visible = false;
    if (this._keyHandler) {
      document.removeEventListener('keydown', this._keyHandler);
      this._keyHandler = null;
    }
  }

  _section(title, shortcuts) {
    const section = el('div', {});
    section.appendChild(el('h3', {}, title));
    for (const [key, desc] of shortcuts) {
      const row = el('div', { className: 'shortcut-row' });
      row.appendChild(el('span', {}, desc));
      row.appendChild(el('span', { className: 'shortcut-key' }, key));
      section.appendChild(row);
    }
    return section;
  }
}
